import { render } from "./040-ThankYou.vue?vue&type=template&id=1c8f5c28&scoped=true"
import script from "./040-ThankYou.vue?vue&type=script&lang=js"
export * from "./040-ThankYou.vue?vue&type=script&lang=js"

import "./040-ThankYou.vue?vue&type=style&index=0&id=1c8f5c28&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8f5c28"]])

export default __exports__